import {
  GET_PIN_FOR_AUTHORIZE,
  GET_PIN_FOR_AUTHORIZE_LOADED,
  GET_PIN_FOR_AUTHORIZE_ERROR,
  GET_CODE_OF_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE_ERROR,
  SET_FORM_PHONE_NUMBER_REQUEST,
  GO_TO_URL_TO_SUBSCRIPTION,
  SET_FORM_PIN_NUMBER_REQUEST,
  SET_URL_FORM_TO_SUBSCRIPTION,
  VALID_INPUT_PHONE,
  VALID_INPUT_PIN,
  EDIT_PHONE_NUMBER,
  SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  VALID_CHECKBOX,
  VALID_EMAIL
} from './constants';

import {
  formatPhoneNumberInternational
} from '../../utils';

export const setPropsFormPhoneNumerRequest = (loading = 1) => ({
  type: SET_FORM_PHONE_NUMBER_REQUEST,
  props: {
    header: 'Digite o número do seu celular Vivo com DDD',
    subheader: '',
    placeholder: '(__)________',
    btncolor: 'primary',
    btntext: 'Continuar',
    isLoading: loading
  }
});

export const setPropsFormPinRequest = () => ({
  type: SET_FORM_PIN_NUMBER_REQUEST,
  props: {
    header: 'Por favor, insira o PIN de 4 dígitos que recebeu por SMS',
    subheader: '',
    placeholder: '____',
    btncolor: 'primary',
    btntext: 'Continuar'
  }
});

export const setUrlFormToSubscription = (url) => ({
  type: SET_URL_FORM_TO_SUBSCRIPTION,
  url
});

export const _onChangeInputPhone = (e) => ({
  type: VALID_INPUT_PHONE,
  phoneNumber: formatPhoneNumberInternational(e.target.value.substring(0, 13).split()
    .filter((n) => (n.substring(0, 1) === '0' ? '' : n))
    .toString()
    .match(/\d+/g))
});

export const _onChangeCheckBox = (e) => ({
  type: VALID_CHECKBOX,
  contactMeByTelOnly: e.target.checked
});

export const _onChangeEmail = (e) => ({
  type: VALID_EMAIL,
  email: e.target.value
});

export const _onChangeInputPin = (e) => ({
  type: VALID_INPUT_PIN,
  pinNumber: e.target.value.substring(0, 4).match(/\d+/g)
});

export const _getPinForAuthorize = (data) => ({
  type: GET_PIN_FOR_AUTHORIZE,
  data
});

export const _getPinForAuthorizeLoaded = (data) => ({
  type: GET_PIN_FOR_AUTHORIZE_LOADED,
  data
});

export const _getPinForAuthorizeError = (error) => ({
  type: GET_PIN_FOR_AUTHORIZE_ERROR,
  error
});

export const _getCodeOfAuthorize = () => ({
  type: GET_CODE_OF_AUTHORIZE
});

export const _getCodeOfAuthorizeLoaded = (data) => ({
  type: GET_CODE_OF_AUTHORIZE_LOADED,
  data
});

export const _getCodeOfAuthorizeError = (error) => ({
  type: GET_CODE_OF_AUTHORIZE_ERROR,
  error
});

export const _goToUrlToSubscription = (url) => ({
  type: GO_TO_URL_TO_SUBSCRIPTION,
  url
});

export const _editPhoneNumber = (phoneNumber) => ({
  type: EDIT_PHONE_NUMBER,
  phoneNumber
});

export const _showMessageWithoutSubscription = ({ subscriptionUri }) => ({
  type: SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  subscriptionUri
});

export default {
  setPropsFormPhoneNumerRequest,
  setPropsFormPinRequest,
  setUrlFormToSubscription,
  _onChangeInputPhone,
  _getPinForAuthorize,
  _getPinForAuthorizeLoaded,
  _getPinForAuthorizeError,
  _goToUrlToSubscription,
  _showMessageWithoutSubscription
};



// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/actions.js